<template>
  <div>
    <el-row :gutter="16">
      <template v-for="item in list">
        <el-col
          :key="item.grid_no"
          :xs="12"
          :sm="8"
          :md="8"
          :lg="8"
          :xl="6"
          style="padding: 8px"
        >
          <el-card>
            <template #header> 格口号：{{ item.grid_name }} </template>
            <div style="padding: 2px 0">
              <span style="color: #333">分播方式：</span>{{ item.method_text }}
            </div>
            <div style="padding: 2px 0">
              <span style="color: #333">格口配置：</span
              >{{ item.method_type_text }}
            </div>
            <div style="padding: 2px 0">
              <span style="color: #333">容器号：</span>{{ item.box_no }}
            </div>
            <div style="padding: 2px 0">
              <span style="color: #333">已播：</span>{{ item.cut_num }}
            </div>
            <div
              style="
                padding: 2px 0;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
              "
            >
              <el-button
                type="success"
                size="small"
                @click="handleViewGrid(item)"
              >
                查看格口
              </el-button>
              <template
                v-if="
                  [constantMap.NORMAL, constantMap.STOCK_SEPARATE].includes(
                    item.method_type
                  )
                "
              >
                <el-button
                  v-if="item.box_no"
                  type="primary"
                  size="small"
                  @click="handleChangeBox(item)"
                >
                  更换容器
                </el-button>
                <el-button
                  v-else
                  type="primary"
                  size="small"
                  @click="handleBindBox(item)"
                >
                  绑定容器
                </el-button>
              </template>
            </div>
          </el-card>
        </el-col>
      </template>
    </el-row>
  </div>
</template>
<script>
const constantMap = {
  // 正常标
  NORMAL: "3",
  // 库存分离标
  STOCK_SEPARATE: "2",
};
export default {
  name: "ReturnAndExchangeCast",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      constantMap,
    };
  },
  methods: {
    handleViewGrid(item) {
      this.$emit("on-view-grid", item);
    },
    handleChangeBox(item) {
      this.$emit("on-change-box", item);
    },
    handleBindBox(item) {
      this.$emit("on-bind-box", item);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/machine/components/ReturnAndExchangeCast.vue